import angular from 'angular'

angular.module('pub.bundle.step6', []).controller('Step6Ctrl', Step6Ctrl)

/** @ngInject */
function Step6Ctrl(
  $scope,
  $state,
  $stateParams,
  BundleService,
  UploadService,
  SetsService,
  ChannelsService,
  DefaultBountyShiniesService,
  ShiniesService,
) {
  var vm = this
  vm.model = {}
  vm.collectibles = []
  vm.products = []
  vm.parentId = $stateParams.parentId
  vm.channelId = $stateParams.channelId
  vm.isChannelBundle = !!$stateParams.channelId
  vm.loadT = false
  vm.loadTM = false
  vm.loadL = false
  vm.pathImgL = ''
  vm.pathImgT = ''
  vm.pathImgTM = ''
  vm.isUpload = true
  vm.isOpen = false
  vm.isOpen1 = false
  vm.isOpen2 = false
  vm.isChannelLevel = false
  vm.aqc = false
  vm.variants = [
    {
      id: 0,
      name: 'Tall Box',
    },
    {
      id: 1,
      name: 'Short Box',
    },
    {
      id: 2,
      name: 'Other',
    },
  ]

  vm.types = [
    {
      id: 1,
      name: 'Standard',
    },
    {
      id: 2,
      name: 'Award',
    },
    {
      id: 3,
      name: 'Starter',
    },
    {
      id: 4,
      name: 'Pre-Sale',
    },
    {
      id: 5,
      name: 'Release',
    },
    {
      id: 6,
      name: 'Mega Pack',
    },
  ]

  vm.maxTypes = [
    {
      id: 0,
      name: 'Max per user',
    },
    {
      id: 1,
      name: 'Max per promo code',
    },
    {
      id: 2,
      name: 'Max per user segment match',
    },
  ]

  vm.priceTypes = [
    {
      id: 1,
      name: 'Free',
    },
    {
      id: 2,
      name: 'Cash',
    },
  ]

  vm.bountyAmounts = []

  vm.options = [
    {
      id: 'Limit',
      checked: false,
    },
    {
      id: 'Sell-out',
      checked: true,
    },
  ]

  vm.lastChoice = vm.options[1]

  vm.title = null
  vm.priceType = vm.priceTypes[1].id
  vm.model.k = vm.types[0].id
  vm.model['k-mpu'] = vm.maxTypes[0].id

  var whichPage = window.location.pathname
  vm.isMegaBundlesPage = whichPage.indexOf('megabundles') !== -1

  vm.openCalendar = function (e, type) {
    e.preventDefault()
    e.stopPropagation()

    if (type === 1) {
      vm.isOpen = true
    } else if (type === 2) {
      vm.isOpen1 = true
    } else {
      vm.isOpen2 = true
    }
  }

  vm.bundleStockStats = null
  function loadStats() {
    BundleService.getBundleStockStats($stateParams.id).then(function (result) {
      let bundleStockStats = result.results

      for (let i = 0; i < bundleStockStats.bsq.length; i++) {
        bundleStockStats.bsq[i].id = i
        bundleStockStats.bsq[i].checked = vm.isChecked(bundleStockStats.bsq[i])
      }
      vm.bundleStockStats = bundleStockStats
    })
  }

  loadStats()

  DefaultBountyShiniesService.listPublish(0, 500).then(function (result) {
    vm.defaultBountyShinies = result.results
  })

  vm.radio = function (value) {
    vm.lastChoice = value
    if (value.id === 'Limit') {
      if (!vm.model.ct || vm.model.ct === 0) {
        vm.model.ct = vm.bundleStockStats['cb-limit']
      }
    } else {
      vm.model.ct = null
    }
  }

  vm.save = function () {
    if (!vm.bountyRate) {
      swal('Error', 'Please enter a bounty rate', 'error')
      return
    }

    const model = {
      ct: vm.model.ct,
      cd: vm.model.cd,
      'id-prod': vm.model['id-prod'],
    }

    BundleService.update($stateParams.parentId, $stateParams.id, model).then(function () {
      BundleService.configureBountyShinyOdds($stateParams.id, { credits: vm.bountyRate }).then(
        function () {
          swal('Success', 'Bounty shiny odds', 'success')
        },
      )
    })
  }

  function load() {
    BundleService.getId($stateParams.parentId, $stateParams.id).then(success)

    function success(result) {
      var bundle = result.results
      vm.model = bundle
      vm.title = bundle.t
      vm.description = bundle.txt
      vm.priceType = vm.model['id-prod'] !== undefined ? 2 : 1
      if (bundle['ts-p'] !== undefined && bundle['ts-p'] !== 0) {
        bundle['ts-p'] = bundle['ts-p']
          .toString()
          .substring(0, bundle['ts-p'].toString().length - 3)
        vm.model['ts-p'] = new Date(parseInt(bundle['ts-p']))
        vm.data1 = angular.copy(vm.model['ts-p'])
      }
      if (bundle['ts-f'] !== undefined && bundle['ts-f'] !== 0) {
        bundle['ts-f'] = bundle['ts-f']
          .toString()
          .substring(0, bundle['ts-f'].toString().length - 3)
        vm.model['ts-f'] = new Date(parseInt(bundle['ts-f']))
        vm.data2 = angular.copy(vm.model['ts-f'])
      }
      if (bundle['ts-x'] !== undefined && bundle['ts-x'] !== 0) {
        bundle['ts-x'] = bundle['ts-x']
          .toString()
          .substring(0, bundle['ts-x'].toString().length - 3)
        vm.model['ts-x'] = new Date(parseInt(bundle['ts-x']))
        vm.data3 = angular.copy(vm.model['ts-x'])
      }
      if (vm.model.bv === null || vm.model.bv === '') {
        vm.bv = 0
      } else if (vm.model.bv === 'box_02.dae') {
        vm.bv = 1
      } else {
        vm.bv = 2
      }

      if (
        (vm.model.ct === undefined || vm.model.ct === null) &&
        vm.model.mpu === 1 &&
        vm.model.c === 0
      ) {
        vm.onboarding = true
      } else {
        vm.onboarding = false
      }

      if (vm.model.st === 10) {
        vm.aqc = true
      }

      if (vm.model.ct > 0) {
        vm.options[0].checked = true
        vm.options[1].checked = false
      }

      if (vm.model['id-ch']) {
        vm.isChannelLevel = true
      } else {
        vm.isChannelLevel = false
      }

      vm.pathImgL = bundle['img-l']
      vm.pathImgT = bundle['img-t']
      vm.pathImgTM = bundle['img-tm']
      vm.isUpload = false

      if ($stateParams.parentId !== '0') {
        SetsService.get($stateParams.parentId).then(function (result) {
          vm.set = result.results
          vm.glossaryName = vm.set.ch['id-gl']
          var data = result.results
          if (data['k-prod'] === 1) {
            vm.typeSet = 'Sticker'
          } else if (data['k-prod'] === 2) {
            vm.typeSet = 'Card'
          } else {
            vm.typeSet = 'Figure'
          }
        })
      } else {
        ChannelsService.get(vm.channelId).then(function (result) {
          vm.channel = result.results
          vm.glossaryName = vm.channel['id-gl']
        })
      }

      BundleService.listProductsPublished().then(function (result) {
        vm.products = result.results
      })
    }
  }

  vm.changeVariant = function (item) {
    if (item === 0) {
      vm.model.bv = ''
    } else if (item === 1) {
      vm.model.bv = 'box_02.dae'
    }
  }

  var watch = $scope.$watch('vm.fileImgT', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadT = false
      return
    }

    if (newVal === null) {
      vm.loadT = false
    }

    vm.loadT = true
    UploadService.save('bundles', newVal, 'img-t', vm.model.id).then(function (fileName) {
      vm.loadT = false
      vm.model['img-t'] = fileName
      vm.pathImgT = fileName
    })
  })

  vm.onbord = function () {
    vm.model.ct = null
    vm.model.mpu = 1
    vm.model.c = 0
  }

  var watch1 = $scope.$watch('vm.fileImgL', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadL = false
      return
    }

    if (newVal === null) {
      vm.loadL = false
    }

    vm.loadL = true
    UploadService.save('bundles', newVal, 'img-l', vm.model.id).then(function (fileName) {
      vm.loadL = false
      vm.model['img-l'] = fileName
      vm.pathImgL = fileName
    })
  })

  var watch2 = $scope.$watch('vm.fileImgTM', function (newVal, oldVal) {
    if (newVal === oldVal) {
      vm.loadTM = false
      return
    }

    if (newVal === null) {
      vm.loadTM = false
    }

    vm.loadTM = true
    UploadService.save('bundles', newVal, 'img-tm', vm.model.id).then(function (fileName) {
      vm.loadTM = false
      vm.model['img-tm'] = fileName
      vm.pathImgTM = fileName
    })
  })

  $scope.$on('$destroy', function () {
    watch()
    watch1()
    watch2()
  })

  load()

  vm.defaultAmounts = function () {
    const product = _.find(vm.products, { price: 0.49 })
    if (!product) {
      swal('Error', 'No product with price 0.49 found', 'error')
      return
    }

    if (vm.lastChoice.id === 'Limit') {
      vm.model.ct = vm.bundleStockStats['cb-limit']
    } else {
      vm.model.ct = 0
    }
    vm.priceType = 2
    vm.model['id-prod'] = product.id
  }

  vm.createdBountyShinies = []

  vm.checkBountyAmount = function (item) {
    const found = _.find(vm.createdBountyShinies, { bty: item.bty })

    if (found) {
      ShiniesService.deleteBountyShiny(item.bundleId, item.bty).then(function () {
        vm.createdBountyShinies = _.filter(vm.createdBountyShinies, function (o) {
          return o.bty !== item.bty
        })
        toastr.success('Deleted')
      })
    } else {
      ShiniesService.createBountyShiny(item.bundleId, item.bty).then(function (result) {
        vm.createdBountyShinies.push(result.results)
        toastr.success('Created')
      })
    }
  }

  vm.pickShiny = function (item) {
    // dbq will have 3 fields:
    // sh - bounty shiny, if it exists
    // dbs - default bounty shiny, if current dbs match
    // q - Collectible
    // IF sh but no dbs:
    // Show shiny info in DBS columns
    // Show collectible info in collectible columns
    // Show shiny status and current odds (I will need to return the odds per million)
    // IF dbs but no sh
    // Show dbs info in DBS columns
    // Show collectible info in collectible columns
    // Show status = “not created”
    // Show odds = - (dash)
    // IF dbs and sh:
    // Show shiny info in DBS columns
    // Show collectible info in collectible columns
    // Show shiny status and current odds (I will need to return the odds per million)

    let obj = {
      thumb: '',
      title: '',
      type: '',
      status: '',
      odds: '',
      q: item.q,
      dbs: item.dbs,
    }
    if ((item?.so && !item?.dbs) || (item?.so && item?.dbs)) {
      obj.thumb = item.so.shiny['img-t']
      obj.title = item.so.shiny.t
      obj.type = item.so.shiny.k
      obj.status =
        item.so.shiny.st === 0
          ? `Unpublished`
          : item.so.shiny.st === 1 && item.so.opm === 0
            ? `Published`
            : item.so.shiny.st === 1 && item.so.opm > 0
              ? `Expired`
              : ``
      obj.odds = item.so.opm
    } else {
      obj.thumb = item.dbs['img-t']
      obj.title = item.dbs.t
      obj.type = 'Not Created'
      obj.odds = '-'
    }

    if (!obj.thumb) {
      obj.thumb = item.q['img-t']
    }

    return obj
  }

  vm.isChecked = function (item) {
    // Everything has a checkbox:
    //   sh and no dbs:
    //   if odds > 0 - checkbox is checked
    //   dbs and no sh - checkbox is unchecked
    //   dbs and sh - checkbox is checked
    if (item?.so && !item?.dbs) {
      if (item.so.opm > 0) {
        return true
      }
    } else if (item?.dbs && !item?.so) {
      return false
    } else if (item?.dbs && item?.so) {
      if (item.so.opm > 0) {
        return true
      }
    }
    return false
  }

  vm.checkboxBounty = function (item) {
    // Checking an unchecked checkbox:
    //   sh and no dbs: Publishes shiny, sets odds to default (i.e. expires any old odds configurations)
    //   dbs and no sh: Calls the usual create bounty shiny endpoint
    //   dbs and sh - should already be checked!
    // Unchecking a checked checkbox:
    //   sh and no dbs: Sets odds to 0 (needs to create 0-odd configuration)
    //   dbs and no sh: should already be unchecked!
    //   dbs and sh - Calls the usual delete bounty shiny endpoint
    // SETTING credit configuration per dollar:
    //   sh and no dbs - if published and odds > 0, includes shiny in new config rates - will update odds config; otherwise, ignored
    //   dbs and no sh - obviously, ignored
    //   dbs and sh - included in odds configuration

    const checked = vm.isChecked(item)
    if (!checked) {
      //sbs and no sh: Calls the usual create bounty shiny endpoint
      if (item?.dbs && !item?.so) {
        ShiniesService.createBountyShiny(parseInt($stateParams.id), item.dbs.bty).then(
          function (result) {
            toastr.success('Created')
            loadStats()
          },
          function (error) {
            loadStats()
          },
        )
      } else if (item?.dbs && item?.so) {
        // dbs and sh - should already be checked!
        ShiniesService.activateShiny(item?.so?.shiny.id).then(
          function (result) {
            toastr.success('Activated')
            loadStats()
          },
          function (error) {
            toastr.warning('Erro to activate shiny')
            loadStats()
          },
        )
      } else if (item?.so && !item?.dbs) {
        // sh and no dbs: Publishes shiny, sets odds to default (i.e. expires any old odds configurations)
        ShiniesService.activateShiny(item?.so?.shiny.id).then(
          function (result) {
            toastr.success('Activated')
            loadStats()
          },
          function (error) {
            toastr.warning('Erro to activate shiny')
            loadStats()
          },
        )
      }
    } else {
      //dbs and sh - Calls the usual delete bounty shiny endpoint
      if (item?.dbs && item?.so) {
        ShiniesService.deleteBountyShiny(parseInt($stateParams.id), item.dbs.bty).then(
          function () {
            toastr.success('Deleted')
            loadStats()
          },
          function () {
            ShiniesService.deactivateShiny(item?.so?.shiny.id).then(
              function (result) {
                toastr.success('Deactivated')
                loadStats()
              },
              function (error) {
                toastr.warning('Erro to deactivated shiny')
                loadStats()
              },
            )
          },
        )
      } else if (item?.so && !item?.dbs) {
        ShiniesService.deactivateShiny(item?.so?.shiny.id).then(
          function (result) {
            toastr.success('Deactivated')
            loadStats()
          },
          function (error) {
            toastr.warning('Erro to deactivated shiny')
            loadStats()
          },
        )
      } else if (item?.dbs && !item?.so) {
        // dbs and no sh: should already be unchecked!
        ShiniesService.deactivateShiny(item?.so?.shiny.id).then(
          function (result) {
            toastr.success('Deactivated')
            loadStats()
          },
          function (error) {
            toastr.warning('Erro to deactivated shiny')
            loadStats()
          },
        )
      }
    }
  }
}
